// Super simple window's localStorage wrapper

export default function localStorage(type = 'localStorage') {
  return {
    setItem: (key, val) => {
      return storageAvailable(type) ? window.localStorage.setItem(`SH_${key}`, val) : null;
    },
    getItem: (key) => {
      return storageAvailable(type) ? window.localStorage.getItem(`SH_${key}`) : null;
    },
    removeItem: (key) => {
      storageAvailable(type) && window.localStorage.removeItem(`SH_${key}`);
    },
  };
}

export function storageAvailable(type) {
  let storage;
  try {
    storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);

    return true;
  } catch (e) {
    const QUOTA_EXCEEDED_ERROR_CODE = 22;
    const FIREFOX_QUOTA_EXCEEDED_ERROR_CODE = 1014;

    if (__CLIENT__) {
      return (
        e instanceof DOMException &&
        (e.code === QUOTA_EXCEEDED_ERROR_CODE || // Everything except Firefox
          e.code === FIREFOX_QUOTA_EXCEEDED_ERROR_CODE || // Firefox
          // Test name field too, because code might not be present
          e.name === 'QuotaExceededError' || // Everything except Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // Firefox
        // Acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }

    return null;
  }
}
